import { SearchEntity } from '../types';

export function getEntityUrl(entitiesCount: Record<SearchEntity, number>) {
  if (entitiesCount.artworks > 0) {
    return SearchEntity.Artworks;
  }

  if (entitiesCount.artists > 0) {
    return SearchEntity.Artists;
  }

  if (entitiesCount.selections > 0) {
    return SearchEntity.Selections;
  }

  return SearchEntity.Artworks;
}
